import { useMsal } from '@azure/msal-react';
import { Button } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { loginRequest } from '../authConfig';

export const Route = createFileRoute('/Unauthorized')({
  component: RouteComponent,
});

function RouteComponent() {
  const { instance } = useMsal();

  const { t } = useTranslation();

  const handleLoginRedirect = () => {
    // instance.loginPopup(); // after successful login, must reload manually to be logged in
    instance.loginRedirect(loginRequest).catch((error) => console.error(error)); // after successful login,  not working with or without reload
  };

  return (
    <div className="collapse navbar-collapse justify-content-end">
      <h2>{instance.getActiveAccount()?.name}</h2>
      <Button onClick={handleLoginRedirect}>{t('misc.login')}</Button>
    </div>
  );
}
